<template>
  <div class="login">
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-half is-offset-one-quarter">
            <div class="box">
              <p class="title is-5">{{ $t('login-view.title') }}</p>
              <b-input @keydown.native.enter="login" v-model="email" :placeholder="$t('login-view.email-placeholder')"
                       tabindex="1"></b-input>
              <br/>
              <b-input @keydown.native.enter="login" v-model="password" type="password"
                       :placeholder="$t('login-view.password-placeholder')"
                       tabindex="2"/>
              <br/>
              <b-button @keydown.native.enter="login" @click="login" type="is-primary" tabindex="3" expanded>{{
                  $t('login-view.login-button')
                }}
              </b-button>
              <b-button @click="resetPassword" type="is-primary is-light" tabindex="4" expanded>{{
                  $t('login-view.password-reset-button')
                }}
              </b-button>
              <p class="subtitle">
                {{ $t('login-view.create-account-text-part1') }}
                <router-link tabindex="5" to="/sign-up">{{ $t('login-view.create-account-text-part2') }}</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    login: function () {
      this.$parent.isLoading = true
      firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(() => {
            this.$parent.isLoading = false
            if (this.isEmailVerified) {
              // load user role from the server after login!
              this.checkUserRoleAndContinue()
            } else {
              this.resendVerification()
            }
          })
          .catch((error) => {
            this.$parent.isLoading = false
            this.showError(error.message)
          });
    },
    resetPassword: function () {
      this.$router.push("reset-password");
    },
    checkUserRoleAndContinue: function () {
      this.loadUserRoleFromServer().then((role) => {
        console.log("signin role: ", role)
        if (role === undefined || role === '' || role === "inactive") {
          this.$buefy.dialog.confirm({
            title: this.$t('pending-user.title').toString(),
            message: this.$t('pending-user.description').toString(),
            confirmText: this.$t('common.ok').toString(),
            cancelText: this.$t('common.close').toString()
          })
          firebase.auth().signOut()
        } else {
          this.$router.replace("projects").catch(() => {
          });
        }
      })
    },
    resendVerification: function () {
      const currentUser = firebase.auth().currentUser
      if (currentUser === null || currentUser === undefined) {
        this.$parent.isLoading = false
        return
      }
      firebase.auth().currentUser.sendEmailVerification()
          .then(() => {
            this.$parent.isLoading = false
            this.showSuccess(this.$t("user-verification.verification-email-sent"));
            this.$buefy.dialog.confirm({
              title: this.$t('user-verification.title').toString(),
              message: this.$t('user-verification.description').toString() + " " + this.email,
              confirmText: this.$t('common.ok').toString(),
              cancelText: this.$t('common.close').toString()
            })
            firebase.auth().signOut()
          })
          .catch((error) => {
            this.$parent.isLoading = false
            this.showError(error.message)
          });
    }
  },
  computed: {
    isEmailVerified() {
      return firebase.auth().currentUser.emailVerified
    }
  }
};
</script>

<style scoped>
.login {
  margin-top: 40px;
}

input {
  margin: 10px 0;
  padding: 15px;
}

button {
  margin-top: 10px;
  padding: 15px;
  cursor: pointer;
}

.subtitle {
  margin-top: 40px;
  font-size: 13px;
}

.subtitle a {
  text-decoration: underline;
  cursor: pointer;
}
</style>